import { render, staticRenderFns } from "./templateInfoModal.vue?vue&type=template&id=244d25f1&scoped=true&"
import script from "./templateInfoModal.vue?vue&type=script&lang=js&"
export * from "./templateInfoModal.vue?vue&type=script&lang=js&"
import style0 from "./templateInfoModal.vue?vue&type=style&index=0&id=244d25f1&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244d25f1",
  null
  
)

export default component.exports